import jump from 'jump.js';

const $return = document.querySelector('.js-c-Footer__returnButton');
const $next = document.querySelector('.js-c-Header__next');
const $tvcm = document.querySelector('.js-tvcm');

$return.onclick = function() {
	jump('body', {
		duration: 1000
	});
};
